import { useCallback, useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { authTokenState } from 'features/auth/state/authAtoms';
import { apiRenderKeyState } from 'shared/state/renderKeyAtoms';
import { fetchPriceSummary } from 'features/price-summary/api/fetchPriceSummary';
import {
  priceSummaryErrorState,
  priceSummaryLoadingState,
  priceSummaryState,
} from 'features/price-summary/state/priceSummaryAtoms';

const PRICE_SUMMARY_POLLING_MS = 5 * 60 * 1000;

export const useFetchPriceSummary = () => {
  const authToken = useRecoilValue(authTokenState);
  const renderKey = useRecoilValue(apiRenderKeyState);
  const setPriceSummary = useSetRecoilState(priceSummaryState);
  const setPriceSummaryLoading = useSetRecoilState(priceSummaryLoadingState);
  const setPriceSummaryError = useSetRecoilState(priceSummaryErrorState);

  const loadPriceSummary = useCallback(async () => {
    if (authToken === '') {
      setPriceSummary(null);
      setPriceSummaryError('');
      setPriceSummaryLoading(false);
      return;
    }

    setPriceSummaryLoading(true);
    const result = await fetchPriceSummary(authToken);

    if (result.summary) {
      setPriceSummary(result.summary);
    }

    setPriceSummaryError(result.errorMessage);
    setPriceSummaryLoading(false);
  }, [
    authToken,
    setPriceSummary,
    setPriceSummaryError,
    setPriceSummaryLoading,
  ]);

  // API操作後の再取得トリガーに追従しつつ、認証完了時にも初回取得する
  useEffect(() => {
    void loadPriceSummary();
  }, [loadPriceSummary, renderKey]);

  // 金額は随時変動するため、画面表示中は定期的に再取得する
  useEffect(() => {
    if (authToken === '') return;

    const timer = window.setInterval(() => {
      void loadPriceSummary();
    }, PRICE_SUMMARY_POLLING_MS);

    return () => {
      window.clearInterval(timer);
    };
  }, [authToken, loadPriceSummary]);
};
